module.exports = __webpack_public_path__ + "static/kushal-ba85e216bfc632aef322fb640b418994.png";